import { cx } from '@libs/classnames';
import { CameraIcon } from '@ui/icons/CameraIcon';
import { HangUpIcon } from '@ui/icons/HangUpIcon';
import { MicIcon } from '@ui/icons/MicIcon';
import { SpeakerIcon } from '@ui/icons/SpeakerIcon';

import styles from './StreamControls.module.css';

export type Props = {
  className?: string;
  micOn: boolean;
  // кнопка камеры есть только там, где ее можно выключать; у судьи камеры нет
  camOn?: boolean;
  // звук судей: кнопка есть только там, где его можно включать (дополнительная камера)
  speakerOn?: boolean;
  disabled?: boolean;
  size?: 'm' | 's';
  onToggleMic?: () => void;
  onToggleCam?: () => void;
  onToggleSpeaker?: () => void;
  onHangUp?: () => void;
};

export function StreamControls({
  className,
  micOn,
  camOn = true,
  speakerOn = false,
  disabled,
  size = 'm',
  onToggleMic,
  onToggleCam,
  onToggleSpeaker,
  onHangUp,
}: Props) {
  return (
    <div className={cx(styles.controls, styles[`is_size_${size}`], className)}>
      {onToggleSpeaker && (
        <button
          type="button"
          className={styles.controls__btn}
          title={speakerOn ? 'Выключить звук судей' : 'Включить звук судей'}
          disabled={disabled}
          onClick={onToggleSpeaker}
        >
          <SpeakerIcon off={!speakerOn} />
        </button>
      )}
      <button
        type="button"
        className={cx(styles.controls__btn, { [styles.is_off]: !micOn })}
        title={micOn ? 'Выключить микрофон' : 'Включить микрофон'}
        disabled={disabled}
        onClick={onToggleMic}
      >
        <MicIcon off={!micOn} />
      </button>
      {onToggleCam && (
        <button
          type="button"
          className={cx(styles.controls__btn, { [styles.is_off]: !camOn })}
          title={camOn ? 'Выключить камеру' : 'Включить камеру'}
          disabled={disabled}
          onClick={onToggleCam}
        >
          <CameraIcon off={!camOn} />
        </button>
      )}
      {onHangUp && (
        <button
          type="button"
          className={cx(styles.controls__btn, styles.is_hangup)}
          title="Завершить трансляцию"
          disabled={disabled}
          onClick={onHangUp}
        >
          <HangUpIcon />
        </button>
      )}
    </div>
  );
}
